import React from 'react';
import { useLoading } from '../context/LoadingContext';

const LoadingAlert: React.FC = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="rounded-lg shadow-2xl p-8 flex flex-col items-center gap-4 max-w-sm" style={{ backgroundColor: 'var(--ih-theme-bg-card)', borderColor: 'var(--ih-theme-border-light)', borderWidth: '1px' }}>
        <div className="relative w-12 h-12">
          <svg
            className="animate-spin w-full h-full"
            style={{ color: 'var(--ih-theme-accent)' }}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <div className="text-center">
          <h3 className="text-lg font-semibold" style={{ color: 'var(--ih-theme-text-primary)', fontFamily: 'var(--ih-font-family-heading)' }}>Processing</h3>
          <p className="text-sm mt-1" style={{ color: 'var(--ih-theme-text-tertiary)' }}>Please wait while we process your request...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingAlert;
